import { render, staticRenderFns } from "./ViewPandi.vue?vue&type=template&id=2661f172&scoped=true&"
import script from "./ViewPandi.vue?vue&type=script&lang=js&"
export * from "./ViewPandi.vue?vue&type=script&lang=js&"
import style0 from "./ViewPandi.vue?vue&type=style&index=0&id=2661f172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661f172",
  null
  
)

export default component.exports